/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { ResultListDataRepresentationUserTaskFilterRepresentation, UserTaskFilterRepresentation } from '../model';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class UserFiltersApi extends BaseApi {
    createUserProcessInstanceFilter(userProcessInstanceFilterRepresentation) {
        throwIfNotDefined(userProcessInstanceFilterRepresentation, 'userProcessInstanceFilterRepresentation');
        return this.post({
            path: '/api/enterprise/filters/processes',
            bodyParam: userProcessInstanceFilterRepresentation
        });
    }
    createUserTaskFilter(userTaskFilterRepresentation) {
        throwIfNotDefined(userTaskFilterRepresentation, 'userTaskFilterRepresentation');
        return this.post({
            path: '/api/enterprise/filters/tasks',
            bodyParam: userTaskFilterRepresentation,
            returnType: UserTaskFilterRepresentation
        });
    }
    deleteUserProcessInstanceFilter(userFilterId) {
        throwIfNotDefined(userFilterId, 'userFilterId');
        const pathParams = {
            userFilterId
        };
        return this.delete({
            path: '/api/enterprise/filters/processes/{userFilterId}',
            pathParams
        });
    }
    deleteUserTaskFilter(userFilterId) {
        throwIfNotDefined(userFilterId, 'userFilterId');
        const pathParams = {
            userFilterId
        };
        return this.delete({
            path: '/api/enterprise/filters/tasks/{userFilterId}',
            pathParams
        });
    }
    getUserProcessInstanceFilter(userFilterId) {
        throwIfNotDefined(userFilterId, 'userFilterId');
        const pathParams = {
            userFilterId
        };
        return this.get({
            path: '/api/enterprise/filters/processes/{userFilterId}',
            pathParams
        });
    }
    getUserProcessInstanceFilters(opts) {
        return this.get({
            path: '/api/enterprise/filters/processes',
            queryParams: opts
        });
    }
    getUserTaskFilter(userFilterId) {
        throwIfNotDefined(userFilterId, 'userFilterId');
        const pathParams = {
            userFilterId
        };
        return this.get({
            path: '/api/enterprise/filters/tasks/{userFilterId}',
            pathParams,
            returnType: UserTaskFilterRepresentation
        });
    }
    getUserTaskFilters(opts) {
        return this.get({
            path: '/api/enterprise/filters/tasks',
            queryParams: opts,
            returnType: ResultListDataRepresentationUserTaskFilterRepresentation
        });
    }
    orderUserProcessInstanceFilters(filterOrderRepresentation) {
        throwIfNotDefined(filterOrderRepresentation, 'filterOrderRepresentation');
        return this.put({
            path: '/api/enterprise/filters/processes',
            bodyParam: filterOrderRepresentation
        });
    }
    orderUserTaskFilters(filterOrderRepresentation) {
        throwIfNotDefined(filterOrderRepresentation, 'filterOrderRepresentation');
        return this.put({
            path: '/api/enterprise/filters/tasks',
            bodyParam: filterOrderRepresentation
        });
    }
    updateUserProcessInstanceFilter(userFilterId, userProcessInstanceFilterRepresentation) {
        throwIfNotDefined(userFilterId, 'userFilterId');
        throwIfNotDefined(userProcessInstanceFilterRepresentation, 'userProcessInstanceFilterRepresentation');
        const pathParams = {
            userFilterId
        };
        return this.put({
            path: '/api/enterprise/filters/processes/{userFilterId}',
            pathParams,
            bodyParam: userProcessInstanceFilterRepresentation
        });
    }
    updateUserTaskFilter(userFilterId, userTaskFilterRepresentation) {
        throwIfNotDefined(userFilterId, 'userFilterId');
        throwIfNotDefined(userTaskFilterRepresentation, 'userTaskFilterRepresentation');
        const pathParams = {
            userFilterId
        };
        return this.put({
            path: '/api/enterprise/filters/tasks/{userFilterId}',
            pathParams,
            bodyParam: userTaskFilterRepresentation,
            returnType: UserTaskFilterRepresentation
        });
    }
}
